import { CSS } from '../../config'

export const scrollButtonStyles: CSS = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '25px',
  color: '$gray0400',
  cursor: 'default'
}
